export const API_ACCESS_KEY_UNSPLASH = "384fbcc04f381cdb5048b027ad70ebdb8f0da39c91f4ae4eae3b08857f9be35c";
export const API_LOCATION_KEY = "71788e7382b628";

export const PHOTOS_PER_PAGE = 10;
export const PHOTOS_ORDER_BY = "popular";
